/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export const FeatureFlagKey = {
    AUTOMATED_BILLING: 'AutomatedBilling'
} as const;
export type FeatureFlagKey = typeof FeatureFlagKey[keyof typeof FeatureFlagKey];

